module.exports = __webpack_public_path__ + "static/media/pores_fullface.06d287e4.svg";